import { Inject, Injectable } from '@angular/core';
// tslint:disable-next-line: max-line-length
import { AdditionalChargesStorageConfig, AppointmentClearCodeStorageConfig, AppointmentStorageConfig, AuthStorageConfig, ConfigSettingsStorageConfig, EquipmentAttributesStorageConfig, EquipmentCategoriesStorageConfig, FailedRequestsStorageConfig, IIonicStorageConfig, InventoryRemovalReasonsStorageConfig, InventoryStatusesStorageConfig, IONIC_STORAGE_CONFIG_TOKEN, PayCodesStorageConfig, PendingTicketProvisionsConfig, SyncStorageConfig, SystemStorageConfig, TicketClearCodeAllowedStorageConfig, TicketClearCodeOptionsStorageConfig, TicketClearCodeTypesStorageConfig, TicketStatusTransitionsStorageConfig, TimeCodesStorageConfig, TimeEntryStorageConfig, TruckInventoryStorageConfig, FormsStorageConfig } from 'src/app/core/config/ionic-storage-config';
import { LocalStorage } from './local-storage';

/**
 * Reference: Ionic Storage w/ Multiple Tables
 * https://stackoverflow.com/a/58368895/12734092
 *
 * Reference: On Bulk operation performance
 * https://stackoverflow.com/a/52555073/12734092
 */
@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {
	appointments: LocalStorage;
	auth: LocalStorage;
	sync: LocalStorage;
	appointmentClearCode: LocalStorage;
	timeEntries: LocalStorage;
	truckInventory: LocalStorage;

	system: LocalStorage;
	configSettings: LocalStorage;
	equipmentAttributes: LocalStorage;
	equipmentCategories: LocalStorage;
	inventoryStatuses: LocalStorage;
	inventoryRemovalReasons: LocalStorage;
	ticketStatusTransitions: LocalStorage;
	ticketClearCodeTypes: LocalStorage;
	ticketClearCodeOptions: LocalStorage;
	ticketClearCodeAllowed: LocalStorage;
	additionalCharges: LocalStorage;
	timeCodes: LocalStorage;
	payCodes: LocalStorage;
	failedRequests: LocalStorage;

	config: IIonicStorageConfig;
	private readonly IDB_VERSION = 'IDB_VERSION';
	pendingTicketProvisions: LocalStorage;
	forms: LocalStorage;

	constructor(
		@Inject(IONIC_STORAGE_CONFIG_TOKEN) IONIC_STORAGE_CONFIG: IIonicStorageConfig,
	) {
		this.config = IONIC_STORAGE_CONFIG;

		// Dynamic
		this.appointments = new LocalStorage(AppointmentStorageConfig);
		this.auth = new LocalStorage(AuthStorageConfig);
		this.sync = new LocalStorage(SyncStorageConfig);
		this.appointmentClearCode = new LocalStorage(AppointmentClearCodeStorageConfig);
		this.timeEntries = new LocalStorage(TimeEntryStorageConfig);
		this.truckInventory = new LocalStorage(TruckInventoryStorageConfig);
		this.pendingTicketProvisions = new LocalStorage(PendingTicketProvisionsConfig);

		// Configuration
		this.system = new LocalStorage(SystemStorageConfig);
		this.configSettings = new LocalStorage(ConfigSettingsStorageConfig);
		this.equipmentAttributes = new LocalStorage(EquipmentAttributesStorageConfig);
		this.equipmentCategories = new LocalStorage(EquipmentCategoriesStorageConfig);
		this.inventoryStatuses = new LocalStorage(InventoryStatusesStorageConfig);
		this.inventoryRemovalReasons = new LocalStorage(InventoryRemovalReasonsStorageConfig);
		this.ticketStatusTransitions = new LocalStorage(TicketStatusTransitionsStorageConfig);
		this.ticketClearCodeTypes = new LocalStorage(TicketClearCodeTypesStorageConfig);
		this.ticketClearCodeOptions = new LocalStorage(TicketClearCodeOptionsStorageConfig);
		this.ticketClearCodeAllowed = new LocalStorage(TicketClearCodeAllowedStorageConfig);
		this.additionalCharges = new LocalStorage(AdditionalChargesStorageConfig);
		this.timeCodes = new LocalStorage(TimeCodesStorageConfig);
		this.payCodes = new LocalStorage(PayCodesStorageConfig);
		this.forms = new LocalStorage(FormsStorageConfig);;

		// Failed Requests
		this.failedRequests = new LocalStorage(FailedRequestsStorageConfig);
	}

	async hasNewIDBVersion(): Promise<boolean> {
		const lastSavedVersion = await this.getIDBVersion();
		if (!lastSavedVersion) {
			this.updateLastIDBVersion();
			return;
		}

		return this.config.VERSION > lastSavedVersion;
	}

	async getIDBVersion(): Promise<number> {
		return Number(await this.system.getItem(this.IDB_VERSION));
	}

	async setIDBVersion(version: number): Promise<void> {
		return await this.system.setItem(this.IDB_VERSION, version);
	}

	async updateLastIDBVersion(): Promise<void> {
		await this.setIDBVersion(this.config.VERSION);
	}

	/**
	 * Until this is refactored and simplified, reference ionic-storage.config.ts
	 * for which tables are dynamic
	 */
	async clearDynamicTables(): Promise<void> {
		this.appointments.clear();
		this.auth.clear();
		this.sync.clear();
		this.appointmentClearCode.clear();
		this.pendingTicketProvisions.clear();
	}
}
